import React from "react";
import { Provider } from "react-redux";
import { ThemeProvider } from "@material-ui/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Application from "../application/components/Application";
import { theme } from "../theme";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "../i18n";

import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import ErrorPanel from "../general-components/ErrorPanel";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import LuxonUtils from "@date-io/luxon";

Bugsnag.start({
  apiKey: process.env.REACT_APP_BUGSNAG_KEY,
  releaseStage: process.env.REACT_APP_CLIENT_ENVIRONMENT,
  enabledReleaseStages: ["production"],
  plugins: [new BugsnagPluginReact(React)],
  appVersion: process.env.REACT_APP_BUILD_NUMBER,
});

const ErrorBoundary = Bugsnag.getPlugin("react");

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: Infinity,
    },
  },
});

const Root = ({ store }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />

      <Provider store={store}>
        <MuiPickersUtilsProvider utils={LuxonUtils}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <React.Suspense fallback="Loading...">
              <ErrorBoundary FallbackComponent={ErrorPanel}>
                <Application />
              </ErrorBoundary>
            </React.Suspense>
          </ThemeProvider>
        </MuiPickersUtilsProvider>
      </Provider>
    </QueryClientProvider>
  );
};

export default Root;
